<template>
    <div>
        <el-dialog :title="'['+form.username+']个人资料中心'"
                   :visible.sync="dialogFormVisible"
                   width="55%"
                   class="userInfoDialog"
        >

            <el-tabs v-model="activeName">
                <el-tab-pane label="基本资料" name="first">
                    <el-form :model="form" :rules="rules" ref="ruleForm" style="text-align: center">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="真实姓名" :label-width="formLabelWidth" :required="true" prop="name">
                                    <el-input v-model="form.name" autocomplete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="出生日期" :label-width="formLabelWidth" :required="true" prop="birth">
                                    <el-date-picker v-model="form.birth" style="width: 100%" type="date"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    placeholder="选择日期"></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="联系电话" :label-width="formLabelWidth" :required="true" prop="mobile">
                                    <el-input v-model="form.mobile" autocomplete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系邮箱" :label-width="formLabelWidth" :required="true" prop="email">
                                    <el-input v-model="form.email" autocomplete="off"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="24" style="text-align: left">
                                <el-form-item label="所属性别" :label-width="formLabelWidth" :required="true" prop="sex">
                                    <el-radio v-model="form.sex" label="1">男</el-radio>
                                    <el-radio v-model="form.sex" label="2">女</el-radio>
                                    <el-radio v-model="form.sex" label="0">未知</el-radio>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="联系地址" :label-width="formLabelWidth">
                                    <el-input v-model="form.liveAddress" autocomplete="off"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="24" style="height: 36px;text-align: right">
                                <el-button size="mini" type="primary" @click="updateInfo('ruleForm')">保 存</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-tab-pane>

                <el-tab-pane label="修改密码" name="second">
                    <el-form :model="pForm" status-icon :rules="pRules" ref="pRuleForm" style="text-align: center">
                        <el-form-item label="旧的密码" :label-width="formLabelWidth" :required="true" prop="pwdOld">
                            <el-input type="password" v-model="pForm.pwdOld" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="新的密码" :label-width="formLabelWidth" :required="true" prop="pwdNew">
                            <el-input type="password" v-model="pForm.pwdNew" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" :label-width="formLabelWidth" :required="true" prop="password">
                            <el-input type="password" v-model="pForm.password" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item style="text-align: right;">
                            <el-button size="mini" type="primary" @click="updatePassword('pRuleForm')">保 存</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogFormVisible: true,
                activeName: 'first',
                roles: [],
                url: '',
                form: {
                    name: '',
                    username: '',
                    birth: '',
                    mobile: '',
                    email: '',
                    liveAddress: '',
                    sex: 1
                },
                rules: {
                    name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
                    birth: [{required: true, message: '请输入出生日期', trigger: 'blur'}],
                    mobile: [{required: true, message: '请输入联系电话', trigger: 'blur'}],
                    email: [{required: true, message: '请输入联系邮箱', trigger: 'blur'}],
                    sex: [{required: true, message: '请选择性别', trigger: 'blur'}]
                },
                pForm: {
                    pwdOld: '',
                    pwdNew: '',
                    password: ''
                },
                pRules: {
                    pwdOld: [{required: true, message: '请输入旧密码', trigger: 'blur'}],
                    pwdNew: [{required: true, message: '请输入新密码', trigger: 'blur'}],
                    password: [{required: true, message: '请确认新密码', trigger: 'blur'}]
                },
                formLabelWidth: '120px'
            };
        },
        methods: {
            int() {

                this.dialogFormVisible = true;
                this.activeName = 'first';

                this.form.name = '';
                this.form.birth = '';
                this.form.mobile = '';
                this.form.email = '';
                this.form.liveAddress = '';
                this.form.sex = 1;

                this.pForm.pwdOld = '';
                this.pForm.pwdNew = '';
                this.pForm.password = '';
                this.$refs['pRuleForm'].resetFields();

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/sys/user/personal'),
                    method: 'post'
                }).then(res => {
                    if (res.data.code == 0) {
                        this.form = res.data.data;
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {
                })
            },
            updatePassword(formName) {
                if (this.pForm.pwdNew !== this.pForm.password) {
                    this.$message({ // 失败
                        type: 'error',
                        message: '两次输入密码不一致!'
                    })
                    return false;
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        this.$httpTAG({
                            url: this.$httpTAG.adornUrl('/business/sys/user/resetPwd'),
                            method: 'post',
                            data: this.$httpTAG.adornData({
                                ...this.pForm
                            })
                        }).then(res => {
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '操作成功！',
                                    type: 'success',
                                    offset: 600
                                });
                                this.dialogFormVisible = false;
                            } else {
                                this.$message({ // 失败
                                    type: 'error',
                                    message: res.data.msg
                                })
                            }
                        }).finally(r => {
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            updateInfo(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        this.$httpTAG({
                            url: this.$httpTAG.adornUrl('/business/sys/user/updatePeronal'),
                            method: 'post',
                            data: this.$httpTAG.adornData({
                                ...this.form
                            })
                        }).then(res => {
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '操作成功！',
                                    type: 'success',
                                    offset: 600
                                });
                                this.dialogFormVisible = false;
                            } else {
                                this.$message({ // 失败
                                    type: 'error',
                                    message: res.data.msg
                                })
                            }
                        }).finally(r => {
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    };
</script>
<style scoped>
    .userInfoDialog >>> .el-dialog__body {
        padding: 0px 85px 30px 20px;
    }

    .userInfoDialog >>> .el-dialog__header {
        text-align: center;
    }

    .userInfoDialog >>> .el-input__suffix {
        top: -1px;
    }
</style>
